const __vite_glob_0_36 = "<svg xmlns=\"http://www.w3.org/2000/svg\" data-name=\"Website Icons\" viewBox=\"0 0 100 100\"><path d=\"M85.09 26.43c1.01.99 1.01 2.62 0 3.62L41.57 73.57a2.541 2.541 0 0 1-3.62 0L14.91 50.53c-1-.99-1-2.62 0-3.62 1-1.01 2.62-1.01 3.62 0l21.23 21.23 41.71-41.71c.99-1 2.62-1 3.62 0Z\"/></svg>";

export { __vite_glob_0_36 as default };
